import { preBookingService, eventService } from '../../services/homii-services';
import _ from 'lodash';
import { GENDERS, HOMII_KEYS } from '../../../utils/constants';
import moment from 'moment';
import localStorageService from '../../services/storage-service/local-storage.service';

const HOMII_PREBOOKING_KEY = HOMII_KEYS.PREBOOKING_KEY;
const HOMII_TRANSACTION_KEY = HOMII_KEYS.TRANSACTION_KEY;
const HOMII_TRANSACTION_CHECKOUT_ID = HOMII_KEYS.TRANSACTION_CHECKOUT_ID;
const HOMII_TRANSACTION_CHECKSUM = HOMII_KEYS.TRANSACTION_CHECKSUM;
const HOMII_EMBEDDED_REDIRECT_URL = HOMII_KEYS.EMBEDDED_REDIRECT_URL;

const STORE_REFERRER = 'store_referrer';

async function getPreBookingQuote(roomTypeId, startDate, endDate, numberOfOccupants, gender, occupantsToSend) {

    let genderNumber = GENDERS.unknown;

    if (gender === 'male') {
        genderNumber = GENDERS.male;
    }
    if (gender === 'female') {
        genderNumber = GENDERS.female;
    }
    try {
        const quote = await preBookingService
            .getPreBookingQuote(
                roomTypeId,
                [],
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD'),
                numberOfOccupants,
                genderNumber,
                occupantsToSend
            );
        return quote;
    } catch (error) {        
        throw Error(
            `${_.get(
                error,
                'response.data.message',
                'An error occurred while trying to create a quote.',
            )} Request ID: ${_.get(error, 'response.headers.x-request-id', 'unknown')}`,
        );
    }        
}

async function createUserPreBooking(expectProvisionalBooking, personId, selectedRoomType, startDate, endDate, numberOfOccupants, occupantsToSend) {
    
    const roomTypeId = _.get(selectedRoomType, 'id');

    let referrer = await localStorageService.getItem(STORE_REFERRER);

    if (referrer) {
        referrer = referrer.toString();
    }

    localStorageService.removeItem(HOMII_PREBOOKING_KEY);

    let response = null;

    try {
        
        response = await preBookingService
            .createUserPreBooking(
                roomTypeId,
                [],
                startDate,
                endDate,
                expectProvisionalBooking,
                numberOfOccupants,
                referrer,
                personId,
                occupantsToSend
            );

        return response;

    } catch (error) {
        throw Error(
            `${_.get(
                error,
                'response.data.message',
                'An error occurred while trying to create a booking.',
            )} Request ID: ${_.get(error, 'response.headers.x-request-id', 'unknown')}`,
        );
    }

}

async function startPreBookingCreditCardEmbeddedPayment() {
    
    const preBookingId = localStorageService.getItem(HOMII_PREBOOKING_KEY);

    if (!preBookingId) {
        throw Error('No prebooking found. Please create a prebooking first.');
    }

    localStorageService.removeItem(HOMII_TRANSACTION_KEY);
    localStorageService.removeItem(HOMII_TRANSACTION_CHECKOUT_ID);
    localStorageService.removeItem(HOMII_TRANSACTION_CHECKSUM);
    localStorageService.removeItem(HOMII_EMBEDDED_REDIRECT_URL);

    try {
        const preBookingPaymentResponse = await preBookingService.preBookingStartEmbeddedPayment(
            false,
            preBookingId,
        );

        const checkoutId = _.get(preBookingPaymentResponse, 'checkoutId');
        const transactionId = _.get(preBookingPaymentResponse, 'creditCardTransactionId');
        const checksum = _.get(preBookingPaymentResponse, 'checksum');
        const redirectUrl = _.get(preBookingPaymentResponse, 'redirectUrl');

        localStorageService.setItem(HOMII_TRANSACTION_KEY, transactionId);
        localStorageService.setItem(HOMII_TRANSACTION_CHECKOUT_ID, checkoutId);
        localStorageService.setItem(HOMII_TRANSACTION_CHECKSUM, checksum);
        localStorageService.setItem(HOMII_EMBEDDED_REDIRECT_URL, redirectUrl);

        eventService.logCustomEvent('start_payment', {
            description: 'Started payment',
        });

    } catch (error) {
        eventService.logCustomEvent('payment_failed', {
            description: `Payment Failed with id ${_.get(
                error,
                'response.headers.x-request-id',
                'unknown',
            )}`,
        });

        throw Error(
            `${_.get(
                error,
                'response.data.message',
                'An error occurred while trying to create a booking.',
            )} Request ID: ${_.get(error, 'response.headers.x-request-id', 'unknown')}`,
        );
    }
    
}

async function sendWaitingList(
    roomTypeId,
    firstName,
    lastName,
    phoneNumber,
    email,
    requestedBookingStartDate,
    requestedBookingEndDate) {
    await preBookingService
        .postWaitingList(
            roomTypeId,
            firstName,
            lastName,
            phoneNumber,
            email,
            requestedBookingStartDate,
            requestedBookingEndDate,
        );
}

export default {
    getPreBookingQuote,
    createUserPreBooking,
    startPreBookingCreditCardEmbeddedPayment,
    sendWaitingList
}
